export const RECURRING_FREQUENCY_DAILY = 1;
export const RECURRING_FREQUENCY_WEEKDAYS = 2;
export const RECURRING_FREQUENCY_WEEKLY = 3;
export const RECURRING_FREQUENCY_MONTHLY = 4;
export const RECURRING_FREQUENCY_YEARLY = 5;

export const RECURRING_FREQUENCY_OPTIONS = [
  { name: "Every Day", value: RECURRING_FREQUENCY_DAILY },
  { name: "Every Week Day", value: RECURRING_FREQUENCY_WEEKDAYS },
  { name: "Weekly", value: RECURRING_FREQUENCY_WEEKLY },
  { name: "Monthly", value: RECURRING_FREQUENCY_MONTHLY },
  { name: "Yearly", value: RECURRING_FREQUENCY_YEARLY },
];

export const EVENT_CONTEXT = "event";

export const EVENT_TYPE_LIVESTREAM = "livestream";
export const EVENT_TYPE_MEETING = "meeting";
export const EVENT_TYPE_IN_PERSON = "in_person";
export const EVENT_TYPE_OTHER = "other";

export const DEFAULT_RECURRING_MONTH_OFFSET = 1;

export const EVENT_TYPE_OPTIONS = [
  { label: "Livestream", value: EVENT_TYPE_LIVESTREAM },
  { label: "Meeting", value: EVENT_TYPE_MEETING },
  { label: "In Person", value: EVENT_TYPE_IN_PERSON },
  { label: "Other", value: EVENT_TYPE_OTHER },
];

export const TICKET_CONFIG_EVENT_TYPES = [
  EVENT_TYPE_LIVESTREAM,
  EVENT_TYPE_MEETING,
  EVENT_TYPE_IN_PERSON,
];

export const ONLINE_EVENT_TYPES = [
  EVENT_TYPE_LIVESTREAM,
  EVENT_TYPE_MEETING,
];

export const DEFAULT_EVENT_VALUES = {
  title: "",
  description: "",
  imageUrl: "",
  meetingLink: "",
  location: "",
  eventType: EVENT_TYPE_LIVESTREAM,
  allowTicketPurchase: false,
  ticketPrice: 0,
  status: "active",
  hashtags: [],

  hideChatOutsideMeeting: false,
  allowEarlyJoin: false,
  earlyJoinMinutes: 0,

  isAllDay: true,
  startTime: "09:00",
  endTime: "17:00",

  recurrenceRule: null,
  recurringStartTimestamp: 0,
  recurringEndTimestamp: 0,

  startTimestamp: 0,
  endTimestamp: 0,
};

export const SAVE_SCOPE_THIS_OCCURRENCE = "this";
export const SAVE_SCOPE_THIS_AND_FOLLOWING = "following";
export const SAVE_SCOPE_WHOLE_SERIES = "all";

export const SAVE_SCOPE_OPTIONS = [
  { value: SAVE_SCOPE_THIS_OCCURRENCE, label: "This event" },
  { value: SAVE_SCOPE_THIS_AND_FOLLOWING, label: "This and following events" },
  { value: SAVE_SCOPE_WHOLE_SERIES, label: "All events" },
];

export const EARLY_JOIN_WINDOW_MINUTES = 15;

export const EVENT_ACTIVE_STATUS = "active";
export const EVENT_INACTIVE_STATUS = "inactive";

export const EVENT_STATUSES = [
  EVENT_INACTIVE_STATUS,
  EVENT_ACTIVE_STATUS,
];
